// The HQ console (`https://hq.{domain}`, spec/14): what `vite build --mode hq` makes. Its copy is the
// console's namespace — sign-in, the second factor, the settings renderer are shared — and HQ's own.
//
// Nothing outside `src/hq/` imports this directory, so the organisation console's build never reaches
// it (vite/surface.ts; `src/__tests__/builds.test.ts` checks both bundles for `HQ_SURFACE_NAME`).

import { consoleResources } from '@clavian/i18n/console';
import { hqResources } from '@clavian/i18n/hq';

import type { ConsoleSurface } from '../surface';
import { createHqRouteTree } from './routes';

/** The HQ build's name, on its document — and the marker the bundle test looks for. */
export const HQ_SURFACE_NAME = 'clavian-hq-console';

export const surface: ConsoleSurface = {
  id: 'hq',
  name: HQ_SURFACE_NAME,
  createRouteTree: createHqRouteTree,
  resources: {
    en: { ...consoleResources.en, ...hqResources.en },
  },
};
